<template>
    <x-dialog v-model="showModal" persistent width="900" max-width="900">
        <template v-slot:activator="{ on }">
            <button v-on="on" type="button">
                <span style="text-decoration: underline">View enquiry history</span>
            </button>
        </template>

        <x-container v-if="loading">
            <loading-spinner/>
        </x-container>

        <x-container v-else>
            <x-layout>
                <x-flex xs12>
                    <h2>Enquiry History</h2>
                </x-flex>
            </x-layout>

            <template v-if="items.length === 0">
                <x-layout>
                    <x-flex xs12>
                        <p>Unable to load enquiry history.</p>
                    </x-flex>
                </x-layout>
            </template>

            <template v-else>
                <x-layout>
                    <x-flex xs12>
                        <table>
                            <tr>
                                <td class="log-table-timestamp">{{ updateDate(items[currentIndex]) }}:</td>
                                <td><strong>Enquiry updated in client system.</strong></td>
                            </tr>
                            <tr>
                                <td class="log-table-timestamp">{{ receivedDate(items[currentIndex]) }}:</td>
                                <td><strong>Update received by Tepfin X.</strong></td>
                            </tr>
                        </table>
                    </x-flex>
                </x-layout>

                <x-layout mt-3>
                    <x-flex xs12>
                        <p v-if="items[currentIndex].status === 'pending'">This update has not yet been processed.</p>
                        <div v-else-if="items[currentIndex].status === 'validation_failed'">
                            <p>This update could not be processed.</p>
                            <ul>
                               <li v-for="error in items[currentIndex].validation_errors">{{ error }}</li>
                            </ul>
                        </div>
                        <data-list v-else :value="toDataList(flatten(items[currentIndex].payload))"/>
                    </x-flex>
                </x-layout>
            </template>

            <x-layout class="response-actions">
                <x-flex xs12 class="text-xs-left">
                    <x-btn
                        class="ma-2"
                        color="tertiary"
                        small
                        @click.stop="closeModal"
                    >
                        Close
                    </x-btn>
                </x-flex>
                <x-flex xs12 class="text-xs-right">
                    <x-btn
                        class="ma-2"
                        color="tertiary"
                        small
                        :disabled="currentIndex <= 0"
                        @click.stop="currentIndex -= 1"
                    >
                        Previous
                    </x-btn>
                    <x-btn
                        class="ma-2"
                        color="secondary"
                        small
                        :disabled="currentIndex >= (items.length - 1)"
                        @click.stop="currentIndex += 1"
                    >
                        Next
                    </x-btn>
                </x-flex>
            </x-layout>
        </x-container>
    </x-dialog>
</template>

<script>
import DataList from "../../Shared/UIComponents/DataList.vue";

export default {
    name: "EnquiryHistoryModal",
    components: {DataList},
    props: {
        manualSubmissionId: {
            type: Number
        }
    },
    async mounted() {
        const response = await axios.get(this.$root.api(`broker/manual-submissions/${this.manualSubmissionId}/automated-submissions`), {responseType:'json'});
        this.items = response.data.data;
        this.loading = false;
    },
    data() {
        return {
            showModal: false,
            loading: true,
            items: [],
            currentIndex: 0,
        }
    },
    methods: {
        flatten(data, prefix = '') {
            const result = {};

            Object.entries(data ?? {}).forEach(([key, value]) => {
                if (typeof value === 'object') {
                    Object.assign(result, this.flatten(value, `${prefix}${key}.`));
                } else {
                    result[`${prefix}${key}`] = value;
                }
            });

            return result;
        },
        toDataList(data) {
            return Object.keys(data).map((key) => ({
                text: key,
                value: data[key],
            }));
        },
        updateDate({resource_created_at, resource_updated_at}) {
            const date = resource_updated_at ?? resource_created_at;

            return this.$moment(date).format("DD MMM YYYY kk:mm");
        },
        receivedDate({created_at}) {
            return this.$moment(created_at).format("DD MMM YYYY kk:mm");
        },
        closeModal() {
            this.showModal = false;
            this.currentIndex = 0;
        }
    }
}
</script>

<style lang="scss" scoped>
.log-table-timestamp {
    text-align: right;
    padding-right: rem(8px);
}
</style>
